// Localizes the backend catalog (categories, service names/descriptions, groups).
// Backend serves French text; these helpers swap in the active-language label,
// falling back to the backend-provided value when no translation key exists.

export const GROUP_SLUG = {
  "Performance": "performance",
  "Émissions": "emissions",
  "Diagnostic": "diagnostic",
  "Sécurité": "security",
  "Airbag": "airbag",
  "Hybride": "hybrid",
  "Transmission": "transmission",
};

const pick = (t, key, fallback) => {
  const v = t(key);
  return v && v !== key ? v : fallback;
};

export const svcName = (s, t) => pick(t, `catalog.svc.${s.id}.name`, s.name);
export const svcDesc = (s, t) => pick(t, `catalog.svc.${s.id}.desc`, s.desc);
export const catLabel = (cat, t) => pick(t, `catalog.cat.${cat.id}.label`, cat.label);
export const catDesc = (cat, t) => pick(t, `catalog.cat.${cat.id}.desc`, cat.desc);
export const groupLabel = (group, t) => {
  const slug = GROUP_SLUG[group];
  return slug ? pick(t, `catalog.group.${slug}`, group) : group;
};

// Credit packs: localize tag + perks for the 4 default packs; custom packs fall back to backend text.
export const packTag = (p, t) => pick(t, `packs.${p.id}.tag`, p.tag);
export const packPerks = (p, t) => {
  const v = t(`packs.${p.id}.perks`);
  return Array.isArray(v) ? v : (p.perks || []);
};
